import React, { useState } from 'react';
import { useApp } from '@/context/AppContext';
import { Button } from '@/components/ui/button';
import { Accessibility, Contrast, Type, RotateCcw, X } from 'lucide-react';

export default function AccessibilityToolbar() {
  const { t, a11y, setA11y } = useApp();
  const [open, setOpen] = useState(false);

  const setFs = (size) => setA11y({ ...a11y, fontSize: size });
  const toggleHc = () => setA11y({ ...a11y, highContrast: !a11y.highContrast });
  const reset = () => setA11y({ fontSize: 'base', highContrast: false });

  return (
    <div className="fixed bottom-4 end-4 z-50">
      {open ? (
        <div className="bg-white border-2 border-border rounded-lg shadow-2xl p-4 w-72" role="dialog" aria-label={t('a11y_title')} data-testid="a11y-panel">
          <div className="flex items-center justify-between mb-3">
            <h3 className="font-bold text-sm">{t('a11y_title')}</h3>
            <button onClick={() => setOpen(false)} aria-label="Close" data-testid="a11y-close" className="p-1 hover:bg-secondary rounded">
              <X className="w-4 h-4" />
            </button>
          </div>

          <div className="space-y-3">
            <div>
              <label className="text-xs font-semibold flex items-center gap-2 mb-2"><Type className="w-4 h-4" aria-hidden="true" /> {t('a11y_font')}</label>
              <div className="flex gap-2">
                {[['base', 'A'], ['lg', 'A+'], ['xl', 'A++']].map(([k, lbl]) => (
                  <button
                    key={k}
                    onClick={() => setFs(k)}
                    data-testid={`a11y-fs-${k}`}
                    className={`flex-1 py-2 rounded border-2 font-bold transition-colors ${a11y.fontSize === k ? 'bg-primary text-primary-foreground border-primary' : 'bg-white border-border hover:bg-secondary'}`}
                  >{lbl}</button>
                ))}
              </div>
            </div>

            <div>
              <label className="text-xs font-semibold flex items-center gap-2 mb-2"><Contrast className="w-4 h-4" aria-hidden="true" /> {t('a11y_contrast')}</label>
              <button
                onClick={toggleHc}
                data-testid="a11y-contrast-toggle"
                className={`w-full py-2 rounded border-2 font-medium ${a11y.highContrast ? 'bg-zayed-ink text-white border-zayed-ink' : 'bg-white border-border hover:bg-secondary'}`}
              >{a11y.highContrast ? 'ON' : 'OFF'}</button>
            </div>

            <Button variant="outline" className="w-full" onClick={reset} data-testid="a11y-reset">
              <RotateCcw className="w-4 h-4 me-2" aria-hidden="true" /> {t('a11y_reset')}
            </Button>
          </div>
        </div>
      ) : (
        <button
          onClick={() => setOpen(true)}
          aria-label={t('open_a11y')}
          data-testid="a11y-toggle"
          className="w-14 h-14 rounded-full bg-primary text-primary-foreground shadow-2xl grid place-items-center hover:bg-primary/90 transition-colors"
        >
          <Accessibility className="w-6 h-6" aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
